import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/ReportStat/:id',
      name: 'ReportStat',
      component: () => import('./views/ReportStat.vue'),
      porps: true
    },
    {
      path: '/ReportTenYear/:id',
      name: 'ReportTenYear',
      component: () => import('./views/ReportTenYear.vue'),
      porps: true
    },
    {
      path: '/ReportTopTen/:id',
      name: 'ReportTopTen',
      component: () => import('./views/ReportTopTen.vue'),
      porps: true
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name === 'ReportStat') {
    if (parseInt(to.params.id, 10) < 6) {
      next()
    } else {
      window.location.replace('/')
    }
  } else {
    next()
  }
})

export default router
